exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".faq-layer[data-v-dfbe0850]{background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);max-width:72%;min-width:66%;padding-left:2rem;padding-right:2rem;position:absolute;top:100%;transition:visibility 0s .2s}", ""]);

